export default {
  custom: {
    label: 'Customized Playables',
    version: {
      table: {
        name: 'Project Name',
        creator: 'Creator',
      },
      apply: {
        label: 'Only Accounts Can Apply',
        delete: {
          label: 'Delete Account Information',
          describe: "This can't be undone. Are you sure to delete?",
        },
      },
      batch: {
        selected: '{num} Selected',
        selectall: 'Select All',
        reverse: 'Invert',
        cancel: 'Clear All',
        apply: 'Apply',
        delete: 'Delete',
      },
    },
    describe:
      'We provide high-quality creative customization and diversified marketing planning services to meet your different marketing goals and scenarios.',
  },
}
